import React from 'react';

import CircularLoading from '../../Common/CircularLoading/CircularLoading';

class WeekPoints extends React.Component {
  render() {
    return (
      <div className="stats-card">
        <div className="circle-icon">
          <i className="icon-star stats-icon" />
        </div>
        {this.props.pointsThisWeekWaiting && (
          <CircularLoading className="loading-resource-gif" />
        )}
        {(this.props.ptsWeek || this.props.ptsWeek === 0) &&
          !this.props.pointsThisWeekWaiting && (
            <p className="title">+{this.props.ptsWeek}</p>
          )}
        {(this.props.ptsWeek || this.props.ptsWeek === 0) &&
          !this.props.pointsThisWeekWaiting && (
            <p className="information">PTS THIS WEEK</p>
          )}
        {this.props.rank && !this.props.pointsThisWeekWaiting && (
          <p className="stats-footer">Ranks {this.props.rank} </p>
        )}
      </div>
    );
  }
}

export default WeekPoints;
